import React from "react";
import { Accordion, Box, Flex, Footer, Heading, Icon, Link, Text } from "@telia/teddy";
import { FooterProps } from "../../../../../../models/footer";
import { getSocialMediaIconFromName } from "./utils";

interface MobileFooterProps {
    footerInfo: FooterProps;
}

const MobileFooter: React.FC<MobileFooterProps> = ({ footerInfo }) => (
    <Footer>
        <Footer.TopRow>
            {footerInfo.bottomRow?.logoColumn && (
                <Link href={footerInfo.bottomRow.logoColumn.url || "/"} variant="navigation-negative">
                    <img
                        src={
                            footerInfo.bottomRow.logoColumn.imageUrl ||
                            "https://www.telia.no/globalassets/system/logo-desktop/telia_logotype_rgb_whitex128.png"
                        }
                        alt={footerInfo.bottomRow.logoColumn.imageAltText || "Telia logo"}
                    />
                </Link>
            )}
            {footerInfo.bottomRow?.socialLinkColumn && (
                <Flex>
                    {footerInfo.bottomRow.socialLinkColumn.links?.map((link, index) => (
                        // oxlint-disable-next-line react/no-array-index-key
                        <Link
                            variant="navigation-negative"
                            href={link.url || "#"}
                            key={`${link.url || link.name}-${index}`}
                        >
                            <Icon
                                size="md"
                                role="img"
                                aria-label={link.name || "Sosiale medier"}
                                name={getSocialMediaIconFromName(link.name)}
                            />
                        </Link>
                    ))}
                </Flex>
            )}
        </Footer.TopRow>

        <Box p="16px">
            <Accordion variant="negative" type="multiple">
                {footerInfo.topRow?.linkColumns?.map((column, index) => (
                    // oxlint-disable-next-line react/no-array-index-key
                    <Accordion.Item
                        value={column.heading || `column-${index}`}
                        key={`accordion-item-${column.heading || index}`}
                    >
                        <Accordion.Header>
                            <Accordion.Trigger>{column.heading}</Accordion.Trigger>
                        </Accordion.Header>
                        <Accordion.Content>
                            <Footer.List>
                                <Footer.Column>
                                    <Footer.LinksList>
                                        {column.links?.map((link, linkIndex) => (
                                            // oxlint-disable-next-line react/no-array-index-key
                                            <Link
                                                variant="text"
                                                href={link.url || "#"}
                                                key={`${link.url || link.name}-${linkIndex}`}
                                            >
                                                {link.name}
                                            </Link>
                                        ))}
                                    </Footer.LinksList>
                                </Footer.Column>
                            </Footer.List>
                        </Accordion.Content>
                    </Accordion.Item>
                ))}
            </Accordion>
        </Box>

        {footerInfo.bottomRow && (
            <Footer.BottomRow>
                {footerInfo.bottomRow.addressColumn && (
                    <Flex direction="column" gap="4px" color="white">
                        {footerInfo.bottomRow.addressColumn.companyName && (
                            <Text variant="paragraph-100" as="p">
                                © {footerInfo.bottomRow.addressColumn.companyName}
                            </Text>
                        )}
                        {footerInfo.bottomRow.addressColumn.officeType && (
                            <Text variant="paragraph-100" as="p">
                                {footerInfo.bottomRow.addressColumn.officeType}
                            </Text>
                        )}
                        {footerInfo.bottomRow.addressColumn.street && (
                            <Text variant="paragraph-100" as="p">
                                {footerInfo.bottomRow.addressColumn.street}
                            </Text>
                        )}
                        {footerInfo.bottomRow.addressColumn.city && footerInfo.bottomRow.addressColumn.postalCode && (
                            <Text variant="paragraph-100" as="p">
                                {footerInfo.bottomRow.addressColumn.city}{" "}
                                {footerInfo.bottomRow.addressColumn.postalCode}
                            </Text>
                        )}
                    </Flex>
                )}
                {footerInfo.bottomRow.linkColumns?.map((column, index) => (
                    // oxlint-disable-next-line react/no-array-index-key
                    <div key={`footer-column-${column.heading || ""}-${index}`}>
                        {column.heading && (
                            <Heading as="h4" color="white" className="title-100">
                                {column.heading}
                            </Heading>
                        )}
                        {column.links?.map((link, linkIndex) => (
                            // oxlint-disable-next-line react/no-array-index-key
                            <Link variant="text" href={link.url || "#"} key={`${link.url || link.name}-${linkIndex}`}>
                                {link.name}
                            </Link>
                        ))}
                    </div>
                ))}
            </Footer.BottomRow>
        )}
    </Footer>
);

export default MobileFooter;
